// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__T0J-k","Auth":"Menu_Auth__1RA3l","NotAuth":"Menu_NotAuth__2j73_"};